import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import zhCommon from './locales/zh/common.json'
import { fixedLocale } from '../src/config/branding'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
      },
      zh: {
        common: zhCommon,
      },
    },
    // 平台固定语言（如 hiam=zh）时锁定，指定 lng 会跳过浏览器自动检测；
    // 未设置则保持原有的检测 + fallback 'en' 行为。
    ...(fixedLocale ? { lng: fixedLocale } : {}),
    fallbackLng: fixedLocale || 'en',
    react: {
        useSuspense: false,
    },
  })

export default i18n